import { render, staticRenderFns } from "./DetailProductInStock.vue?vue&type=template&id=08334af8"
import script from "./DetailProductInStock.vue?vue&type=script&lang=js"
export * from "./DetailProductInStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports